import { FC } from 'react';
import { Divider } from 'antd';
import { FormBuilderFieldHeader } from 'types/formBuilder';

interface FieldHeaderProps {
  data: FormBuilderFieldHeader;
}

const FieldHeader: FC<FieldHeaderProps> = ({ data }) => {
  return (
    <div>
      <div style={{ marginTop: 8, fontSize: 18 }}>{data.label}</div>

      <Divider />
    </div>
  );
};

export default FieldHeader;
